<template>
<div class="wrapper">
    <main>
        <div class="contentModule">
            <div class="invitationTitle">我的邀请</div>
            <div class="flex-wrap invite">
                <div class="inviteLink">
                    <div class="flex-wrap">
                        <span>我的邀请链接：</span>
                        <span class="link"><input id="copyVal" v-model="urlInvite" placeholder="无" readonly="readonly" /></span>
                        <span style="flex: 1"><input class="copyLink" type="button" @click="copyLink()" value="复制链接" /></span>
                    </div>
                </div>
                <div class="inviteCode">

                    <vue-qr  ref="Qrcode" :text="data.url" :logoSrc="data.icon" :size="120" :margin="10"></vue-qr>
                    <!--<qrcode :url="data.url" :iconurl="data.icon" :wid="200" :hei="200" :imgwid="53" :imghei="53"></qrcode>-->
                    <div class="space-between">
                        我的邀请二维码
                      <el-button type="text" style="color:#67C23A;" @click="downloadImg()">保存</el-button>
                       <!-- <a :href="data.url" target="_blank" name="file" download="我的邀请二维码.png" @click="downloadImg()" class="saveCode">保存</a>-->
                    </div>
                </div>
            </div>
            <div>
                <div style="line-height: 40px;font-weight: bold">我的邀请记录</div>
                <div class="orderList">
                  <el-table
                    :data="tableData"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    border
                    default-expand-all>
                    <el-table-column
                      prop="account"
                      label="邀请人帐号">
                    </el-table-column>
                    <el-table-column
                      prop="createTime"
                      label="注册时间">
                    </el-table-column>
                    <el-table-column
                      prop="orderCount"
                      label="出单状态">
                      <template slot-scope="scope">
                        <div v-if="scope.row.orderCount==0">未出单</div>
                        <div v-if="scope.row.orderCount==1">出单</div>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div class="block">
                    <el-pagination
                      background
                      @size-change="handleSizeChange"
                      @current-change="getShipListByMemberId"
                      :current-page.sync="page"
                      :page-sizes="[10, 20, 30, 40]"
                      :page-size="1"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="total">
                    </el-pagination>
                  </div>
                </div>
            </div>
        </div>
    </main>
</div>
</template>

<script>

    import vueQr from 'vue-qr';
    export default {
        name: 'App',
        components:{
            vueQr
        },
        data(){
            return{
                showViewer:false,
                showViewerTwo:false,
                tableData:[],
                page: 1,
                total: 0,
                pageSize: 10,
                urlInvite:"",
                data:{
                    url: "",
                    icon:"../../../../static/images/dutyInsurance/logoIcon.png",
                }

            };
        },
        methods: {
            downloadImg() {
                const iconUrl = this.$refs.Qrcode.$el.src;
                let a = document.createElement('a');
                let event = new MouseEvent('click');
                a.download = '我的邀请二维码';
                a.href = iconUrl;
                a.dispatchEvent(event);
            },
            copyLink(){
                let copyVal = document.getElementById("copyVal");
                copyVal.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                alert("已复制好，可贴粘。");
            },
            handleSizeChange(val) {
                this.page = 1;
                this.pageSize = val;
                this.getShipListByMemberId();
            },
            onSelect(){
                this.page = 1;
                this.getShipListByMemberId();
            },
            getShipListByMemberId(){
                this.axios.post('/member/userrelationship/getShipListByMemberId', {
                    "_current": this.page,
                    "_pageSize": this.pageSize,
                    "memberId": localStorage.getItem("memberId")
                },).then((response) => {
                    if (response.data.success) {
                        let {list, pagination } = response.data.datas;
                        this.tableData = list;
                        this.page = pagination.current;
                        this.total = pagination.total;
                        this.loading = false;
                    } else {
                        this.$message.error(response.data.msg);
                    }
                });
            }
        },
        mounted() {
            let url = this.$$.getFullHost() + '/html/dutyInsurance/login.html';
            if (this.$$.isValidObj(localStorage.getItem("memberId"))) url = url + `?memberId=${localStorage.getItem("memberId")}`;
            this.data.url = url;
            this.urlInvite = url;
            // console.log(url);

            // this.creatQrCode();
            this.getShipListByMemberId();

        },
    }

</script>
<style scoped>
  @import "../../../../static/css/dutyInsurance/myInvitation.css";
  @import "../../../../static/css/reset.css";

  .orderList /deep/ .el-table__body-wrapper{
    overflow: auto;
  }

  .orderList /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px;
    height: 8px;
  }

  .orderList /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb{
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #CCCCCC;
  }

  .orderList /deep/ .cell{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/dutyInsurance/myInvitation.vue